import difference from 'lodash/difference';
import values from 'lodash/values';
import invert from 'lodash/invert';
import getUrlBase from './utils/get-base-url';
import { language } from '../constants';

export const LANGUAGE_KEYS_MAP = {
  en: 'e',
  he: 'h',
  ru: 'r',
  fr: 'f'
};

export const SHORT_LINK_REDIRECT_MAP = {
  'home-details': 'a'
};

const languageMap = invert(LANGUAGE_KEYS_MAP);
const languageKeys = Object.keys(languageMap);
const shortLinkMap = invert(SHORT_LINK_REDIRECT_MAP);
const shortLinkRedirectKeys = Object.keys(shortLinkMap);

export const checkConsistentLanguageMapping = (langs, keys) => {
  const diffKeys = difference(
    langs || language.supportedLanguages,
    keys || Object.keys(LANGUAGE_KEYS_MAP)
  );

  if (diffKeys.length) {
    throw new Error(`Update the language map key in short-link-handler, missing [${diffKeys.join(', ')}]`);
  }
};

export const getLocaleByKey = (key, forRoute = false) => {
  if (languageKeys.indexOf(key[0]) !== -1) {
    let locale = languageMap[key[0]];

    locale = locale === language.default ? '' : locale;
    locale = locale && forRoute ? `${locale}/` : locale;

    return {
      locale,
      key: key.substr(1)
    };
  }
  return {
    locale: '',
    key
  };
};

const transformParts = (parts) => {
  if (parts.length === 3) {
    const [locale, prefix, id] = parts;
    if (Object.keys(LANGUAGE_KEYS_MAP).includes(locale) && shortLinkRedirectKeys.includes(prefix)) {
      return [`${locale[0]}${prefix}`, id];
    }
  }
  return parts;
};

const shortLinkHandler = (request, response, next) => {
  let parts = request.url.split('/').filter(p => p);
  parts = transformParts(parts);

  if (parts.length === 2 && parts[0].length <= 2) {
    const id = parts[1];
    const { key, locale } = getLocaleByKey(parts[0], true);

    if (shortLinkRedirectKeys.indexOf(key) !== -1) {
      const urlBase = getUrlBase(request, { returnLocalhost: true });
      const fullUrl = `${urlBase}/${locale}${shortLinkMap[key]}/${id}`;

      return response.redirect(301, fullUrl);
    }
  }

  return next();
};

checkConsistentLanguageMapping();

export default shortLinkHandler;
